import { useCallback, useState } from "react";

const useForceUpdate = () => {
  const [, setValue] = useState(false);

  return useCallback(() => setValue(currVal => !currVal), []);
};

export default useForceUpdate;
